export const FETCH_LINKED_ALERTS_ERROR = 'FETCH_LINKED_ALERTS_ERROR' as const;
export const SEARCH_ALERTS_ERROR = 'SEARCH_ALERTS_ERROR' as const;
